<!-- <demographic></demographic> -->
<div fxLayout="row wrap" fxLayoutAlign="center" [@animateStagger]="{value:'50'}">

    <!-----------boton finalizar paso---------->
    <div fxLayout="row" fxLayoutAlign="end end" class="mb-20 finishBt">
        <!--<div class="content-card">
            <h3>Guía de Referencia III</h3>
            <h3>IDENTIFICACIÓN Y ANÁLISIS DE LOS FACTORES DE RIESGO PSICOSOCIAL Y EVALUACIÓN DEL ENTORNO ORGANIZACIONAL EN LOS CENTROS DE TRABAJO</h3>
            <p>El contenido de esta guía es un complemento para la mejor comprensión de la presente Norma, y no es de cumplimiento obligatorio, puede ser utilizada por aquellos centros de trabajo que cuenten con más de 50 trabajadores.</p>
            <p>La identificación y análisis de los factores de riesgo psicosocial y la evaluación del entorno organizacional a que se refiere el numeral 8.1, inciso b) de la presente Norma, se podrá realizar aplicando el cuestionario siguiente:</p>
        </div>-->

        <!--<div class="content-card" *ngFor="let datita of preguntas">
            <p>{{datita.def}}</p>
            <table class="blueTable" *ngFor="let ques of datita.que">
                <tbody>
                    <tr>
                        <td>{{ques.id}}</td>
                        <td>{{ques.pregunta}}</td>
                        <td></td>
                    </tr>

                </tbody>
            </table>


        </div>-->
    </div>
</div>